/**
 * Component types for the component form wizard
 * These must match the keys in i18n/locales/{lang}/component-types.json
 * Simplified to remove duplicates and subcategories
 */

export const COMPONENT_TYPES = [
  // Applications
  'application',
  'api',
  'service',
  'function',
  'saas',

  // Data Storage
  'database',
  'storage',
  'cache',
  'queue',
  'data_lake',
  'message_broker',

  // Infrastructure
  'server',
  'virtual_machine',
  'container',
  'container_orchestrator',
  'container_registry',
  'cluster',
  'load_balancer',
  'cdn',

  // Network
  'network',
  'firewall',
  'proxy',
  'gateway',
  'vpn',
  'dns',

  // Security
  'identity_provider',
  'secret_manager',
  'security_zone',

  // Zones
  'zone',
  'cloud_platform',

  // Platform
  'platform',
  'integration_platform',

  // CI/CD
  'cicd_pipeline',
  'gitops',

  // Monitoring
  'monitoring_service',
  'logging_service',
  'backup_service',

  // Other
  'other',
] as const;

export type ComponentType = (typeof COMPONENT_TYPES)[number];
